export function resolvePublicUrl() {
    // Read process.env.PUBLIC_URL directly so bundler `define` replacement inlines
    // the configured value. Guarding with `typeof process !== 'undefined'` breaks
    // this: the guard itself is not replaced and is false in browsers, so the
    // inlined value was unreachable and we always fell back to the first path
    // segment — wrong under a feature-deploy prefix (/CCW-1234/...). The try/catch
    // covers environments where `process` doesn't exist and no define is applied.
    let configuredPublicUrl;
    try {
        configuredPublicUrl = process.env.PUBLIC_URL;
    } catch {
        configuredPublicUrl = undefined;
    }

    if (
        configuredPublicUrl &&
        configuredPublicUrl !== 'undefined' &&
        configuredPublicUrl !== 'null'
    ) {
        if (configuredPublicUrl === '/') {
            return '';
        }

        return configuredPublicUrl.endsWith('/')
            ? configuredPublicUrl.slice(0, -1)
            : configuredPublicUrl;
    }

    if (typeof window === 'undefined') {
        return '';
    }

    const [firstPathSegment] = window.location.pathname.split('/').filter(Boolean);
    return firstPathSegment ? `/${firstPathSegment}` : '';
}
